import * as Marzipano from "marzipano";
import Shepherd from "shepherd.js";

import { sendEvent } from "./events.js";
import { data, viewer, resetSceneButton } from "../data-config";
import { createInfoHotspotElement } from "./infoHotspots";
import { createLinkHotspotElement } from "./linkHotspots";
import { setupNavigationArrows } from "./navArrows.js";

const controls = document.getElementById("controls");
const controlsClose = document.getElementById("controls-close");
const intro = document.getElementById("intro");
const introClose = document.getElementById("intro-close");
const tourAccept = document.getElementById("tour-accept");
const tourReject = document.getElementById("tour-reject");

// Create scenes.
const scenes = data.scenes.map((data) => {
    const urlPrefix = "tiles";
    const source = Marzipano.ImageUrlSource.fromString(
        urlPrefix + "/" + data.id + "/{z}/{f}/{y}/{x}.jpg",
        { cubeMapPreviewUrl: urlPrefix + "/" + data.id + "/preview.jpg" }
    );

    const geometry = new Marzipano.CubeGeometry(data.levels);

    const limiter = Marzipano.RectilinearView.limit.traditional(
        data.faceSize,
        (100 * Math.PI) / 180,
        (120 * Math.PI) / 180
    );

    const view = new Marzipano.RectilinearView(
        data.initialViewParameters,
        limiter
    );

    const scene = viewer.createScene({
        source: source,
        geometry: geometry,
        view: view,
        pinFirstLevel: false,
    });

    // Create "reset view" button element
    data.returnToView?.map((viewRequested) => {
        resetSceneButton.setAttribute("data-id", `${viewRequested.id}`);
        resetSceneButton.addEventListener("click", function () {
            switchScene(
                scenes.find((scene) => scene.data.id === viewRequested.target)
            );
            resetSceneButton.classList.add("hidden");
            // temp gtags event handler
            // sendEvent("Experience", "clicked reset view button", `${resetSceneButton.textContent}`);
        });
    });

    // Create link hotspots.
    data.linkHotspots.forEach(function (hotspot) {
        const element = createLinkHotspotElement(hotspot);
        scene
            .hotspotContainer()
            .createHotspot(element, { yaw: hotspot.yaw, pitch: hotspot.pitch });
    });

    // Create info hotspots.
    data.infoHotspots.forEach(function (hotspot) {
        const element = createInfoHotspotElement(hotspot);
        scene
            .hotspotContainer()
            .createHotspot(element, { yaw: hotspot.yaw, pitch: hotspot.pitch });
    });

    return {
        data: data,
        scene: scene,
        view: view,
    };
});

// Listen for tour events to send to GTM
tourAccept.addEventListener("click", (e) => {
    sendEvent("welcome", "accepted tour");
});

tourReject.addEventListener("click", (e) => {
    sendEvent("welcome", "rejected tour");
});

function initTour() {
    // Create Tour + Tour Handlers
    const tourLookToScene_01 = {
        ...data.tourParams.tourSection1,
    };

    const options = {
        transitionDuration: 2000,
    };

    const tourLookToScene_02 = {
        ...data.tourParams.tourSection2,
    };

    const options_linkHotspot = {
        transitionDuration: 2000,
    };

    const start_tour = tourAccept;

    const initTourSection = new Shepherd.Tour({
        exitOnEsc: false,
        useModalOverlay: true,
    });

    const secondTourSection = new Shepherd.Tour({
        useModalOverlay: false,
        exitOnEsc: false,
    });

    // Tour step 1
    initTourSection.addStep({
        id: "first",
        showOn: document.body.classList.contains("tour-accepted"),
        text: `<br/>Click this icon to learn<br/>more about the product<br/><br/>`,
        modalOverlayOpeningPadding: 10,
        modalOverlayOpeningRadius: 20,
        attachTo: {
            element:
                ".intro-starter .info-hotspot-icon-wrapper .info-hotspot-icon",
            on: "top",
        },

        popperOptions: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 25],
                    },
                },
            ],
        },
    });

    start_tour.addEventListener("click", function () {
        const ih = document.querySelector(".intro-starter");
        introModalOverlay.remove();
        ih.addEventListener("click", () => {
            setTimeout(() => {
                Shepherd.activeTour ? initTourSection.next() : null;
                document.body.classList.remove("tour-init");
            }, 600);
        });

        viewer.controls().disable();
        intro.classList.remove("visible");
        intro_scene.lookTo(tourLookToScene_01, options, done);
        document.body.classList.add("tour-accepted");
    });

    function done() {
        initTourSection.start();
    }

    initTourSection.addStep({
        id: "second",
        arrow: false,
        modalOverlayOpeningPadding: 0,
        text: `<br/>Here, you'll find <br/> product information,
<br/>inspiration &<br/> related content`,
        attachTo: {
            element: ".info-hotspot-modal.visible .product-txt-container",
            on: "auto",
        },
        popperOptions: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 20],
                    },
                },
            ],
        },
        buttons: [
            {
                text: "Next",
                action: initTourSection.next,
                classes: "shep-next",
            },
        ],
    });

    initTourSection.addStep({
        id: "third",
        arrow: false,
        showOn: document.body.classList.contains("tour-accepted"),
        text: `<br/>Here you'll find product images & videos<br/>`,
        attachTo: {
            element: ".info-hotspot-modal.visible .carousel_container",
            on: "auto",
        },
        popperOptions: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 25],
                    },
                },
                {
                    name: "arrow",
                    options: {
                        padding: 25,
                    },
                },
            ],
        },
        buttons: [
            {
                text: "Back",
                action: initTourSection.back,
                classes: "shep-back",
            },
            {
                text: "Done",
                action: () => {
                    sendEvent("tour", "completed tour");
                    viewer.controls().enable();
                    return initTourSection.complete();
                },
                classes: "shep-next",
            },
        ],
    });

    // secondTourSection.addStep({
    //     id: "fourth",
    //     showOn: document.body.classList.contains("tour-accepted"),
    //     text: `<br/>Click the arrow to see the products in this part of the kitchen<br/><br/>`,
    //     attachTo: {
    //         element: ".second-tour-starter img.link-hotspot-icon",
    //         on: "auto",
    //         action() {
    //             return this.complete();
    //         },
    //     },
    //     popperOptions: {
    //         modifiers: [
    //             {
    //                 name: "offset",
    //                 options: {
    //                     offset: [0, 15],
    //                 },
    //             },
    //         ],
    //     },
    // });

    const tour_movement = new Shepherd.Tour({
        exitOnEsc: false,
        defaultStepOptions: {
            scrollTo: { behavior: "smooth", block: "center" },
        },
    });

    tour_movement.addStep({
        showOn: document.body.classList.contains("tour-accepted"),
        text: `<br/>Good moves! I think you got the hang of it!<br/>`,
        buttons: [
            {
                text: "Start Exploring",
                classes: "shep-next",
                action() {
                    sendEvent("tour", "completed tour");
                    viewer.controls().enable();
                    return this.complete();
                },
            },
        ],
        popperOptions: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 25],
                    },
                },
            ],
        },
    });

    const exit_tour = document.querySelector(".cancel");
    const exit_tour_x = document.querySelector(
        ".intro-header .intro-close"
    );
    const intro_scene = scenes[0].scene;
    const introLH = document.querySelector(
        ".link-hotspot.second-tour-starter"
    );
    const introModalOverlay = document.querySelector(
        ".info-hotspot-modal.intro-bg"
    );

    initTourSection.on("complete", function () {
        const header = document.querySelector(".intro-starter");
        const currModal = document.querySelector(
            ".info-hotspot-modal.visible"
        );
        header.classList.remove(".intro-starter");
        currModal.classList.remove("visible");
        setTimeout(() => {
            currModal.remove();
        }, 3000);
        intro_scene.lookTo(
            tourLookToScene_01,
            options_linkHotspot,
            infoHotspotsTour_done
        );
        sendEvent("tour", "clicked next button", "step 3");
    });

    initTourSection.on("show", (e) => {
        switch (e.step.id) {
            case "second":
                if (
                    typeof e.previous != "undefined" &&
                    e.previous.id == "third"
                ) {
                    sendEvent("tour", "clicked back button", "step 3");
                } else {
                    sendEvent(
                        "tour",
                        "clicked product info button",
                        "step 1"
                    );
                }
                break;
            case "third":
                sendEvent("tour", "clicked next button", "step 2");
                break;
        }
    });

    function infoHotspotsTour_done() {
        secondTourSection.start();
    }

    // introLH.addEventListener("click", function () {
    //     Shepherd.activeTour
    //         ? secondTourSection.next() + tour_movement.start()
    //         : null;
    // });

    secondTourSection.on("complete", () => {
        Shepherd.activeTour.steps.forEach((step) => {
            step.destroy();
        });
        sendEvent("tour", "clicked scene button", "step 4");
    });

    tour_movement.on("complete", function () {
        switchScene(scenes[0]);
        Shepherd.activeTour.steps.forEach((step) => {
            step.destroy();
        });
        document.body.classList.remove("tour-accepted");

        viewer.controls().enable();
        // introLH.classList.remove("second-tour-starter");
    });

    [exit_tour, exit_tour_x].forEach((el) => {
        el.addEventListener("click", function () {
            // introLH.classList.remove("second-tour-starter");
            intro.remove();
            document.querySelector(".intro-bg").classList.remove("visible");
            viewer.controls().enable();
        });
    });

    introClose.addEventListener("click", function () {
        intro.classList.remove("visible");
        document.querySelector(".intro-bg").classList.remove("visible");
        // introLH.classList.remove("second-tour-starter");
    });

    controlsClose.addEventListener("click", function () {
        controls.classList.remove("visible");
        setTimeout(() => {
            intro.style.opacity = 1;
            intro.classList.add("visible");
        }, 1000);
    });
}

// setup navigation arrows
setupNavigationArrows();

export function findSceneById(id) {
    for (let i = 0; i < scenes.length; i++) {
        if (scenes[i].data.id === id) {
            if (scenes[i].data.returnToView) {
                resetSceneButton.classList.remove("hidden");
            } else {
                resetSceneButton.classList.add("hidden");
            }
            return scenes[i];
        }
    }
    return null;
}

export function findSceneDataById(id) {
    for (let i = 0; i < data.scenes.length; i++) {
        if (data.scenes[i].id === id) {
            return data.scenes[i];
        }
    }
    return null;
}

export function resetIframes() {
    const yt = document.getElementsByTagName("iframe");
    if (yt != null) {
        for (let i = 0; i < yt.length; i++) {
            yt[i].src = yt[i].src;
        }
    }
}

export function switchScene(scene) {
    scene.view.setParameters(scene.data.initialViewParameters);
    scene.scene.switchTo();
}

export function init() {
    initTour()
    switchScene(scenes[0]);
}